import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import Rating from '@material-ui/lab/Rating';

import { useCourseMainDataQuery } from '../../hooks/use-course-main-data-query';
import { useCourseReviewDataQuery } from '../../hooks/use-course-review-data-query';
import FluidImgs from '../fluidImgs';
import { WayToViewConsumer } from '../../contexts/wayToViewList';
import Badge from '../badge';

import Card from '../../../node_modules/react-bootstrap/esm/Card';
import Button from '../../../node_modules/react-bootstrap/esm/Button';

import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';

const CardWrapper = styled.article`
  a {
    text-decoration: none;
  }

  .card {
    &:hover {
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    }
  }
  .card-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    min-height: 45px;
    margin-bottom: 5px;
    font-size: 0.875rem;
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: 700;
    line-height: 1.4;
    color: #151515;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .card-body {
    height: 210px;
  }
  .instructors {
    margin-bottom: 5px;
    font-size: 0.8rem;
    color: #777;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .MuiRating-root > span {
    margin-right: -3px;
  }
  .price {
    margin-top: -3px;
    color: #304354;
    font-weight: bold;
    font-size: 0.938rem;
    letter-spacing: -0.5px;
  }
  .card-img {
    height: 100%;
  }
  .badges {
    margin-top: 10px; 
  }
  .badge {
    display: inline-block;
    min-height: 22px;
    margin-top: 7px;
    margin-right: 5px;
    padding: 0 8px;
    font-size: 0.625rem;
    border-radius: 5px;
    line-height: 22px;
    color: #151515;

    // TODO: 왜 안되지???
    & + & {
      margin-right: 5px;
      color: #fff;
    }
  }
  .medium-cate-badge {
    background-color: #fde1e1;
  }
  .small-cate-badge {
    background-color: #e4e4f1;
  }
  .neabeaca-badge {
    background-color: #e1f7fd;
  }
  .businessClass-badge {
    background-color: #e1fde4;
  }
  .normalClass-badge {
    background-color: #fde1fd;
  }
  /* IE10+ */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    padding: 13px;
  }
  .only-show-list-view {
    display: none;
  }

  .list-view {
    .card {
      border: 0px !important;
      border-top: 1px solid #eee !important;
      box-shadow: none !important;
      margin-bottom: 0px !important;
    }
    .card-title {
      min-height: auto;
      margin-top: 5px;
    }
    .course-card-info {
      .instructors {
        order: 3;
      }
      .review-rating {
        order: 2;
        margin-bottom: 5px;
      }
      .price {
        display: none;
      }
      .badges {
        order: 1;
        margin-bottom: 5px;
        margin-top: 0;
      }
    }
    .only-show-list-view {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 1rem;
      padding-left: 1rem;
      .price {
        display: block;
        font-size: 1.2rem;
        margin-bottom: 0.5rem;
      }
    }
  }
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  color: #9c9c9c;
  margin-bottom: 0.05rem;
  svg {
    margin: 0 -2px 0 -1px;
  }
`;

const CourseCardLink = props => {
  // RMP 과정 메인 데이터
  const GetCourseList = () => {
    const courseList = [];
    const courses = useCourseMainDataQuery();

    let filtered = courses.allCourseList33Sheet1XlsxSheet1.edges
    .filter(courseEdge => courseEdge.node.large_categories === props.cateName) ;

    if(props.midCateName) {
      filtered = filtered.filter(courseEdge => courseEdge.node.medium_categories === props.midCateName);
    }
      
    filtered
      .slice(0, props.sliceNum && props.sliceNum) // 보여지는 카드 갯수 props로 제한하기
      .forEach(courseEdge => {
        courseList.push({
          classTitle: courseEdge.node.class_title,
          id: courseEdge.node.id,
          largeCate: courseEdge.node.large_categories,
          instructor: courseEdge.node.instructors_and_affiliation,
          price: courseEdge.node._total_price_,
          neabeaca: courseEdge.node.neabaca_grants,
          businessClass: courseEdge.node._small_businesses_grants_,
          mediumCate: courseEdge.node.medium_categories,
          smallCate: courseEdge.node.small_categories,
          classCode: courseEdge.node.class_code,
          thumnail: courseEdge.node.thumnail,
        });
      });

    return courseList;
  };

  const courseList = GetCourseList();

  // 리뷰 데이터
  const GetReviewRate = () => {
    // 리뷰데이터 넣을 빈 배열 생성
    const reviewRateList = [];
    // 리뷰 카운터
    const reviewCountList = {};
    // 리뷰데이터 쿼리 불러와서 담기
    const reviewRates = useCourseReviewDataQuery();

    reviewRates.allCourseList33ReviewXlsxSheet1.edges.forEach(
      reviewRateEdge => {
        reviewRateList.push({
          reviewClassCode: reviewRateEdge.node.class_code,
          starRate: reviewRateEdge.node.star_rate,
        });
        if(!reviewCountList[reviewRateEdge.node.class_code]){
          reviewCountList[reviewRateEdge.node.class_code] = 0;
        }
        reviewCountList[reviewRateEdge.node.class_code]++;
      },
    );
    return [reviewRateList, reviewCountList];
  };

  const reviewRateList = GetReviewRate()[0];
  const reviewCountList = GetReviewRate()[1];

  const getCourseReview = function(course) {
    let reduced = reviewRateList.reduce(
      (accReviewRate, currReviewRate) => {
        if (currReviewRate.reviewClassCode === course.classCode) {
          accReviewRate[0] += parseFloat(currReviewRate.starRate);
          accReviewRate[1]++;
        }
        //console.log(accReviewRate);
        return accReviewRate;
      },
      [0, 0],
    );
    return Math.ceil((reduced[0] / reduced[1]) * 2) / 2 || 0;
  };

  return (
    <>
      <WayToViewConsumer>
        {value => (
          <>
            {courseList.map(course => (
              <CardWrapper
                key={course.id}
                className={`
                ${
                  value.state.viewList === 'list-view'
                    ? 'mb-0'
                    : 'mb-3 col-12 col-sm-6 col-lg-4 col-xl-3 h-100 px-2'
                }
              `}
              >
                <Link
                  className={value.state.viewList}
                  to={`/hrd-course/${course.classCode}`}
                >
                  <Card className="text-decoration-none shadow-sm">
                    {course.thumnail ? (
                      <div className="card-img">
                        <FluidImgs
                          filename={course.thumnail}
                          objectFit="cover"
                          alt={course.title + '- Featured Shot'}
                          type="mobileFullWidth"
                        />
                      </div>
                    ) : (
                      <div className="card-img">
                        <FluidImgs
                          filename={`default-thumnail16x9.jpg`}
                          objectFit="cover"
                          alt="썸네일 준비중"
                          type="mobileFullWidth"
                        />
                      </div>
                    )}
                    <Card.Body className="ps-0 p-sm-3">
                      <Breadcrumb>
                      <span>{course.largeCate}</span><IoIosArrowForward /><span>{course.mediumCate}</span>
                      </Breadcrumb>
                      <Card.Title className="text-decoration-none">
                        {course.classTitle}
                      </Card.Title>
                      <div className="course-card-info d-flex flex-column">
                        <div className="instructors">{course.instructor}</div>
                        <div className="d-flex align-items-center review-rating">
                          <Rating
                            className="rating-stars me-1 mb-0"
                            name="half-rating-read"
                            // 리뷰 별점 || 리뷰 별점 없을 경우
                            defaultValue={getCourseReview(course)}
                            precision={0.5}
                            size="small"
                            readOnly
                            />
                          <span style={{color: 'gray'}}>{
                            reviewCountList[course.classCode]
                            ? reviewCountList[course.classCode]
                            : 0
                          }명</span>
                          
                        </div>
                        <div className="price">₩{course.price}</div>
                        <div className="badges">
                          {course.businessClass.trim() !== '-' && (
                            <Badge classKind="businesses_grants">
                              사업주훈련
                            </Badge>
                          )}
                          {course.neabeaca.trim() !== '-' && (
                            <Badge classKind="neabaca_grants">
                              내일배움카드
                            </Badge>
                          )}
                          {(course.neabeaca.trim() === '-' && course.businessClass.trim() === '-') && (
                            <Badge classKind="normalClass">일반과정</Badge>
                          )}
                        </div>
                      </div>
                    </Card.Body>
                    <div className="only-show-list-view">
                      <div className="price">₩{course.price}</div>
                      <style type="text/css">
                        {`
                          .btn-orange {
                            background-color: #ff7e33;
                            color: #fff;
                          }
                          .btn-orange:hover {
                            background-color: #eb5e00;
                            color: #fff;
                          }
                        `}
                      </style>
                      <Button variant="orange">과정보기</Button>
                    </div>
                  </Card>
                </Link>
              </CardWrapper>
            ))}
          </>
        )}
      </WayToViewConsumer>
    </>
  );
};

export default CourseCardLink;
